<template>
    <div>
        <spinner v-if="isLoaded == false"></spinner>
        <div class="card">
            <card v-show="isLoaded == true">
                <div slot="header" class="row justify-content-between">
                    <h4 slot="header" class="card-title"> {{ fnc.id === '' && this.$route.params.type !== 0 ? 'Création' :
                        'Modification'
                    }} d'une fiche de non conformité</h4>

                    <n-button slot="header" type="primary" class="btn-sm btn-primary col-3 col-lg-1 ml-auto mr-5"
                        @click.native="backToList()">
                        Retour
                    </n-button>
                </div>

                <div class="m-2">
                    <form>
                        <!-- information générale de la fiche -->
                        <div class="row">
                            <div class="col-md-4 col-xl-2">
                                <label class="input-label">N° d'ordre FNC</label>
                                <fg-input name="num" placeholder="ex: FNC-22-06" v-validate="'required'"
                                    :error="errors.first('num')" v-model="fnc.num" @focus="duplicateFncNum = false"
                                    @blur="checkDuplicateFncNum()" :class="duplicateFncNum ? 'has-danger' : ''" />
                                <slot name="helpBlock">
                                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'"
                                        v-if="duplicateFncNum">
                                        Ce numéro de FNC est déjà utilisé
                                    </div>
                                </slot>
                            </div>
                            <div class="col-md-4 col-xl-2 ">
                                <label class="input-label">Date de réception</label>
                                <fg-input class="fnc-date-field" name="received_at" v-validate="'required'"
                                    :error="errors.first('received_at')" addon-left-icon="now-ui-icons far fa-calendar-alt"
                                    v-model="fnc.received_at">
                                    <flat-picker ref="received_at" slot-scope="{focus, blur}" :config="flatpickr_config"
                                        class="datepicker" :placeholder="'Choisir une date'" v-model="fnc.received_at">
                                    </flat-picker>
                                </fg-input>
                            </div>

                            <div class=" col-md-4 col-xl-2 ">
                                <label class="input-label">Lieu de réception</label>
                                <fg-input class="select" name="location" v-validate="'required'" v-model="fnc.location">
                                    <el-select id="location" :class="errors.first('location') ? 'has-error' : ''"
                                        placeholder="Choisir un lieu de réception" no-data-text="aucune données"
                                        v-model="fnc.location" filterable>
                                        <el-option v-for="location in location.options" :key="location" :label="location"
                                            :value="location"></el-option>
                                    </el-select>
                                    <slot name="helpBlock">
                                        <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'"
                                            v-if="errors.first('location')">
                                            {{ errors.first('location') }}
                                        </div>
                                    </slot>
                                </fg-input>
                            </div>
                            <div class="col-md-4 col-xl-2">
                                <label class="input-label">Déclarée par</label>
                                <fg-input class="select" v-model="fnc.declared_by">
                                    <el-select id="controller" placeholder="Choisir un déclarant" v-model="fnc.declared_by"
                                        filterable>
                                        <el-option v-for="controller in controller.options" :key="controller.id"
                                            :label="controller.name" :value="controller.id"></el-option>
                                    </el-select>
                                </fg-input>
                            </div>
                        </div>


                        <!-- origine d'une Fnc -->
                        <div class="row">
                            <h4 class="part-header col-12">Origine de la NC :</h4>
                            <div class="col-md-4 col-xl-3 mb-3">
                                <div class="btn-group" role="group" style="width: 100%">
                                    <a @click="selected_origin = false"
                                        :class="selected_origin === false ? 'importance-1 radius-1' : 'importance-2 radius-1'"
                                        style="width: 50%">
                                        INTERNE
                                    </a>
                                    <a @click="selected_origin = true"
                                        :class="selected_origin === true ? 'importance-1 radius-2' : 'importance-2 radius-2'"
                                        style="width: 50%">
                                        EXTERNE
                                    </a>
                                </div>
                            </div>
                            <div class="col-md-4 col-xl-3">
                                <label class="input-label">Origine</label>
                                <fg-input class="select" name="origin" v-model="fnc.origin" v-validate="'required'">
                                    <el-select id="origin" :class="errors.first('origin') ? 'has-error' : ''"
                                        placeholder="Choisir une origine" v-model="fnc.origin" filterable>
                                        <el-option v-show="selected_origin === true" v-for="origin in origin_extern.options"
                                            :key="origin" :label="origin" :value="origin"></el-option>
                                        <el-option v-show="selected_origin === false"
                                            v-for="origin in origin_intern.options" :key="origin.id" :label="origin.name"
                                            :value="origin.id"></el-option>
                                    </el-select>
                                    <slot name="helpBlock">
                                        <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'"
                                            v-if="errors.first('origin')">
                                            {{ errors.first('origin') }}
                                        </div>
                                    </slot>
                                </fg-input>
                            </div>
                            <div v-if="selected_origin === false" class="col-md-4 col-xl-3">
                                <label class="input-label">Détectée par</label>
                                <fg-input class="select" name="detected_by" v-model="fnc.detected_by"
                                    v-validate="'required'">
                                    <el-select id="detected_by" :class="errors.first('detected_by') ? 'has-error' : ''"
                                        placeholder="Choisir le détecteur" no-data-text="aucunes données"
                                        v-model="fnc.detected_by" filterable>
                                        <el-option v-for="controller in controller.options"
                                            v-if="fnc.origin !== '' && fnc.origin !== null && fnc.origin === controller.department_id"
                                            :key="controller.id" :label="controller.name"
                                            :value="controller.id"></el-option>
                                    </el-select>
                                    <slot name="helpBlock">
                                        <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'"
                                            v-if="errors.first('detected_by')">
                                            {{ errors.first('detected_by') }}
                                        </div>
                                    </slot>
                                </fg-input>
                            </div>
                        </div>

                        <!-- Cause d'une Fnc -->
                        <div class="row">

                            <div class="col-xl-9">
                                <h4 class="part-header">Constat de la NC :</h4>
                                <div class="row">
                                    <div class="col-xl-6">
                                        <div class="row">
                                            <div class="col-md-6 col-xl-6">
                                                <label class="input-label">Référence produit</label>
                                                <fg-input class="select" name="product_id" v-validate="'required'"
                                                    v-model="fnc.product_id">
                                                    <el-select id="product"
                                                        :class="errors.first('product_id') ? 'has-error' : ''"
                                                        placeholder="Choisir un produit" v-model="fnc.product_id"
                                                        filterable>
                                                        <el-option v-for="product in product.options" :key="product.id"
                                                            :label="product.reference + ' - ' + product.name"
                                                            :value="product.id"></el-option>
                                                    </el-select>
                                                    <slot name="helpBlock">
                                                        <div class="text-danger invalid-feedback" style="display: block"
                                                            :class="'mt-2'" v-if="errors.first('product_id')">
                                                            {{ errors.first('product_id') }}
                                                        </div>
                                                    </slot>
                                                </fg-input>
                                                <label class="input-label">Quantité</label>
                                                <fg-input type='number' name="quantity" class="select"
                                                    v-validate="'min_value:1|required'" :error="errors.first('quantity')"
                                                    v-model="fnc.quantity" />
                                            </div>

                                            <div class="col-md-6 col-xl-6 order-2 order-xl-0">
                                                <label class="input-label">N° Fournisseur</label>
                                                <fg-input class="select" name="supplier_id" v-validate="'required'"
                                                    v-model="fnc.supplier_id">
                                                    <el-select id="supplier"
                                                        :class="errors.first('supplier_id') ? 'has-error' : ''"
                                                        placeholder="Choisir un fournisseur" no-data-text="aucunes données"
                                                        v-model="fnc.supplier_id" filterable>
                                                        <el-option v-if="supplier.productIdList.includes(fnc.product_id)"
                                                            v-for="supplier in supplier.options" :key="supplier.id"
                                                            :label="supplier.num + '  ' + supplier.name"
                                                            :value="supplier.id"></el-option>
                                                    </el-select>
                                                    <slot name="helpBlock">
                                                        <div class="text-danger invalid-feedback" style="display: block"
                                                            :class="'mt-2'" v-if="errors.first('supplier_id')">
                                                            {{ errors.first('supplier_id') }}
                                                        </div>
                                                    </slot>
                                                </fg-input>
                                                <label class="input-label">Contact</label>
                                                <fg-input class="select" name="contact_id" v-model="fnc.contact_id">
                                                    <el-select id="contact"
                                                        :class="errors.first('contact_id') ? 'has-error' : ''"
                                                        placeholder="Choisir un contact" v-model="fnc.contact_id"
                                                        filterable>
                                                        <el-option v-if="contact.supplier_id === fnc.supplier_id"
                                                            v-for="contact in contact.options" :key="contact.id"
                                                            :label="contact.email" :value="contact.id"></el-option>
                                                    </el-select>
                                                </fg-input>

                                              <label class="input-label">Récurrence</label>
                                              <fg-input class="select" name="recurence"
                                                        v-model="fnc.recurence">
                                                <el-select id="recurence" placeholder="Choisir une récurrence" v-model="fnc.recurence">
                                                  <el-option label="Oui" :value="1"></el-option>
                                                  <el-option label="Non" :value="0"></el-option>
                                                </el-select>
                                              </fg-input>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12 col-xl-4 order-2 order-xl-0">
                                        <label class="input-label">Constat</label>
                                        <fg-input class="select" name="cause" data-vv-as="constat" v-model="fnc.cause" v-validate="'required'">
                                            <el-select id="cause" placeholder="Veuillez saisir le constat de non-conformité"
                                                v-model="fnc.cause" clearable no-data-text="aucunes données" allow-create
                                                filterable default-first-option>
                                                <el-option v-for="cause in fnc.causes" :key="cause.cause"
                                                    :label="cause.cause" :value="cause.cause"></el-option>
                                            </el-select>
                                            <slot name="helpBlock">
                                                <div class="text-danger invalid-feedback" style="display: block"
                                                    :class="'mt-2'" v-if="errors.first('cause')">
                                                    {{ errors.first('cause') }}
                                                </div>
                                            </slot>
                                        </fg-input>
                                        <div class="order-3 order-xl-0">
                                            <label class="input-label">Observations internes</label>
                                            <fg-input>
                                                <textarea class="form-control test" id="intern_observation" name="intern_observation"
                                                    v-model="fnc.intern_observation" rows="4" maxlength="255"
                                                    placeholder="Veuillez saisir vos observations internes (Optionnel).">
                                            </textarea>
                                                <p class="comment">{{ intern_observation_sizeLimit }}</p>
                                            </fg-input>
                                        </div>

                                    </div>
                                    <div class="col-md-6 offset-md-3 offset-xl-0 col-xl-2 mb-3">
                                        <div class="btn-group" role="group" style="width: 100%">
                                            <a @click="selected_importance = false"
                                                :class="selected_importance === false ? 'importance-1 radius-1' : 'importance-2 radius-1'"
                                                style="width: 50%">
                                                MINEURE
                                            </a>
                                            <a @click="selected_importance = true"
                                                :class="selected_importance === true ? 'importance-1 radius-2' : 'importance-2 radius-2'"
                                                style="width: 50%">
                                                MAJEURE
                                            </a>
                                        </div>
                                        <div class="text-center mt-3">
                                            <!-- TODO Dupliquer les images deja existante lors de l'ajout d'une nouvelle images  -->
                                            <label for="file" class="label-file py-2">Ajouter une pièce
                                                jointe</label>
                                            <input id="file" type='file' @change="filesChange($event.target.files)" multiple
                                                accept=".jpeg, .jpg, .png, .gif, .tif, .pdf, .svg" class="d-none" />
                                        </div>
                                        <div class="d-flex justify-content-center " v-for="(file, index) in fnc.files" :key="file.id || index">
                                            <a class="text-truncate" href="#" @click.prevent="openImageInNewTab(file.base64)"  target="blank">{{ file.name }}</a>
                                            <n-button class="remove-btn" @click.native="removeFile(index)">X</n-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-3 order-3 order-xl-0">
                                <h4 class="part-header">Suivi :</h4>
                                <label class="input-label">Responsable</label>
                                <fg-input class="select" v-model="fnc.controlled_by">
                                    <el-select id="controller" placeholder="Choisir un controlleur"
                                        v-model="fnc.controlled_by" filterable>
                                        <el-option v-for="controller in controller.options" :key="controller.id"
                                            :label="controller.name" :value="controller.id"></el-option>
                                    </el-select>
                                </fg-input>
                            </div>

                        </div>

                        <!-- Actions d'une Fnc -->
                      <div class="row">

                        <!-- ===================== A C T I O N S ===================== -->
                        <div class="col-xl-6">
                          <div class="row">
                            <h4 class="col-12 part-header">Actions :</h4>

                            <!-- === Colonne CURATIVE (col-6) === -->
                            <div class="col-md-6">
                              <div class="d-flex align-items-center justify-content-between mb-2">
                                <label class="mb-0">Curative</label>
                                <el-switch v-model="curative_action" active-color="#f96332" inactive-color="#eaeaea"></el-switch>
                              </div>

                              <!-- Contenu actif -->
                              <div v-if="curative_action">
                                <label class="input-label">Action curative immédiate</label>
                                <fg-input>
                                  <textarea
                                      name="currative_action"
                                      v-validate="curative_action ? 'required' : ''"
                                      :class="errors.first('currative_action') ? 'has-error' : ''"
                                      class="form-control test"
                                      v-model="fnc.currative_action"
                                      rows="4"
                                      maxlength="255"
                                      placeholder="Décrivez l'action curative à mener."
                                  ></textarea>
                                  <p class="comment">{{ currative_action_sizeLimit }}</p>
                                </fg-input>
                                <slot name="helpBlock">
                                  <div class="text-danger invalid-feedback" style="display:block" :class="'mt-2'"
                                       v-if="errors.first('currative_action')">
                                    {{ errors.first('currative_action') }}
                                  </div>
                                </slot>

                                <label class="input-label">Efficacité</label>
                                <fg-input class="select" v-model="fnc.efficiency">
                                  <el-select id="efficiency" :class="errors.first('efficiency') ? 'has-error' : ''"
                                             placeholder="Choisir une efficacité" v-model="fnc.efficiency" filterable>
                                    <el-option v-for="eff in efficiency.options" :key="eff" :label="eff" :value="eff"></el-option>
                                  </el-select>
                                </fg-input>

                                <div class="mt-3">
                                  <label class="input-label">Date de l'action curative</label>
                                  <fg-input class="fnc-date-field" name="curative_action_date" addon-left-icon="now-ui-icons far fa-calendar-alt">
                                    <flat-picker
                                        ref="curative_action_date"
                                        slot-scope="{focus, blur}"
                                        :config="flatpickr_config"
                                        class="datepicker"
                                        :placeholder="'Choisir une date'"
                                        v-model="fnc.curative_action_date"
                                    ></flat-picker>
                                  </fg-input>
                                </div>
                              </div>

                              <!-- Placeholder quand inactif -->
                              <div v-else class="p-3 rounded bg-light text-muted"
                                   style="border:1px dashed #e3e3e3; min-height:140px;">
                                <p class="mb-1"><strong>Action curative non activée.</strong></p>
                                <p class="mb-0">
                                  Activez le switch en haut à droite pour saisir :
                                  l’action curative immédiate, son efficacité et la date associée.
                                </p>
                              </div>
                            </div>

                            <!-- === Colonne CORRECTIVE (col-6) === -->
                            <div class="col-md-6">
                              <div class="d-flex align-items-center justify-content-between mb-2">
                                <label class="mb-0">Corrective</label>
                                <el-switch v-model="corrective_action" active-color="#f96332" inactive-color="#eaeaea"></el-switch>
                              </div>

                              <!-- Contenu actif -->
                              <div v-if="corrective_action">
                                <label class="input-label">Actions correctives</label>
                                <fg-input>
                                  <textarea
                                      name="corrective_action"
                                      v-validate="(corrective_action || fnc.importance === 'majeure') ? 'required' : ''"
                                      :class="errors.first('corrective_action') ? 'has-error' : ''"
                                      class="form-control test"
                                      v-model="fnc.corrective_action"
                                      rows="4"
                                      maxlength="255"
                                      placeholder="Décrivez les actions correctives à mener."
                                  ></textarea>
                                  <p class="comment">{{ corrective_action_sizeLimit }}</p>
                                </fg-input>


                                <div v-show="fnc.importance === 'majeure'">
                                  <label class="input-label">Efficacité corrective</label>
                                  <fg-input class="select" v-model="fnc.corrective_efficiency">
                                    <el-select
                                        id="corrective_efficiency"
                                        placeholder="Choisir une efficacité"
                                        v-model="fnc.corrective_efficiency"
                                        clearable
                                        filterable>
                                      <el-option label="Efficace" :value="'Efficace'"></el-option>
                                      <el-option label="Partiellement Efficace" :value="'Partiellement Efficace'"></el-option>
                                      <el-option label="Non Efficacce" :value="'Non Efficacce'"></el-option>
                                    </el-select>
                                  </fg-input>
                                </div>

                                <slot name="helpBlock">
                                  <div class="text-danger invalid-feedback" style="display:block" :class="'mt-2'"
                                       v-if="errors.first('corrective_action')">
                                    {{ errors.first('corrective_action') }}
                                  </div>
                                </slot>

                                <!-- Délai impératif (switch en préfixe + date grisée si OFF) -->
                                <div class="mt-3">
                                  <label class="input-label ml-0 d-block">Délai</label>

                                  <div class="d-flex align-items-center">
                                    <!-- Switch en préfixe -->
                                    <el-switch
                                        v-model="time_limit"
                                        active-color="#f96332"
                                        inactive-color="#eaeaea"
                                        class="mr-3">
                                    </el-switch>

                                    <!-- Champ date toujours visible mais (dés)activé selon le switch -->
                                    <fg-input
                                        name="time_limit"
                                        addon-left-icon="now-ui-icons far fa-calendar-alt"
                                        class="fnc-date-field flex-grow-1">
                                      <flat-picker
                                          ref="time_limit"
                                          slot-scope="{focus, blur}"
                                          :config="flatpickr_config"
                                          class="datepicker"
                                          :placeholder="time_limit ? 'Choisir une date' : 'Activez le délai pour choisir une date'"
                                          v-model="fnc.time_limit"
                                          :disabled="!time_limit">
                                      </flat-picker>
                                    </fg-input>
                                  </div>
                                </div>

                              </div>

                              <!-- Placeholder quand inactif -->
                              <div v-else class="p-3 rounded bg-light text-muted"
                                   style="border:1px dashed #e3e3e3; min-height:140px;">
                                <p class="mb-1"><strong>Action corrective non activée.</strong></p>
                                <p class="mb-0">
                                  Activez le switch en haut à droite pour décrire les actions correctives
                                  et, si besoin, définir un délai impératif.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>


                        <!-- ===================== C L Ô T U R E ===================== -->
                        <div class="col-xl-6">
                          <div class="row">
                            <h4 class="col-12 part-header">Clôture :</h4>

                            <div class="col-md-6 col-xl-6">
                              <label class="input-label">Date de clôture</label>
                              <fg-input class="fnc-date-field" name="archived_at"
                                        addon-left-icon="now-ui-icons far fa-calendar-alt"
                                        v-model="fnc.archived_at">
                                <flat-picker
                                    ref="archived_at"
                                    slot-scope="{focus, blur}"
                                    :disabled="(fnc.archived_at !== null) || !canCloseFnc"
                                    :config="flatpickr_config"
                                    class="datepicker"
                                    :placeholder="'Choisir une date'"
                                    v-model="fnc.archived_at">
                                </flat-picker>
                              </fg-input>
                              <p v-if="fnc.importance === 'majeure' && !hasCorrectiveAction"
                                 class="text-danger mb-3" style="font-size: 10px">
                                Pour clôturer une FNC majeure, saisissez d’abord une action corrective.
                              </p>
                            </div>

                            <!-- ⚠️ Efficacité retirée de Clôture, déplacée côté Actions (curative) -->

                            <div class="col-md-6 col-xl-6">
                              <label class="input-label">Coût</label>
                              <fg-input type='number' name="cost" class="select" placeholder="ex: 555.55"
                                        v-model="fnc.cost" />
                            </div>

                            <div class="col-md-6 col-xl-6">
                              <label class="input-label">Visa Responsable</label>
                              <fg-input class="select" v-model="fnc.controlled_by">
                                <el-select id="controller" placeholder="Choisir un contrôleur"
                                           v-model="fnc.controlled_by" filterable>
                                  <el-option v-for="controller in controller.options" :key="controller.id"
                                             :label="controller.name" :value="controller.id"></el-option>
                                </el-select>
                              </fg-input>
                            </div>

                            <div class="col-md-6 col-xl-6">
                              <label class="input-label">Visa Direction</label>
                              <fg-input class="select" v-model="fnc.directed_by">
                                <el-select id="director" placeholder="Choisir un responsable de direction"
                                           v-model="fnc.directed_by" filterable>
                                  <el-option v-for="controller in controller.options"
                                             v-if="managers.includes(controller.id)"
                                             :key="controller.id"
                                             :label="controller.name" :value="controller.id"></el-option>
                                </el-select>
                              </fg-input>
                            </div>

                            <div class="col-12">
                              <label class="input-label">Commentaires</label>
                              <fg-input>
                                <textarea class="form-control test" id="comment" name="comment" rows="4"
                                          maxlength="255" v-model="fnc.comments"
                                          placeholder="Saisissez vos commentaires (Optionnel).">
                                </textarea>
                                <p class="comment">{{ comment_sizeLimit }}</p>
                              </fg-input>
                            </div>
                          </div>
                        </div>

                      </div>

                    </form>

                    <div class="d-flex justify-content-center">
                        <button type="submit" class="col-2 btn btn-sm btn-primary radius" @click=" busy = true, save()"
                            :disabled="busy">Enregistrer</button>
                        <button v-if="fnc.id !== '' && this.$route.params.type !== 1"
                            class="col-2 btn btn-sm btn-suppr radius" @click="deletedModal()">Supprimer</button>
                    </div>
                </div>

                <!-- Modal de suppression d'une Fnc -->
                <modal :show.sync="deleteModal" headerClasses="justify-content-center">
                    <h4 slot="header">{{ fnc.num }}</h4>
                    <h4 class="text-center mt-0">
                        Etes vous sûre de vouloir la <br>
                        supprimer?<br>
                        (Cette action est définitive et <br>
                        irréversible)
                    </h4>
                    <div class="row justify-content-around">
                        <button class="col-5 btn btn-sm btn-primary radius" @click="deleteModal = false">Annuler</button>
                        <button class="col-5 btn btn-sm btn-suppr radius" @click="deleteFnc()">Supprimer</button>
                    </div>
                </modal>
                <fnc-closure-modal :show="closureModal" :number="fnc.num"
                                   @close="finishClosure(false)" @prepare="finishClosure(true)" />
            </card>
        </div>
    </div>
</template>

<script>
import FncClosureModal from './FncClosureModal.vue'
import moment from 'moment';
import Form from 'vform'
import { Select, Option, Switch } from 'element-ui'
import Spinner from "../../../components/Spinner/Circle"
import flatPicker from "vue-flatpickr-component"
import 'flatpickr/dist/flatpickr.css'
import { Modal } from 'src/components'
import { French } from 'flatpickr/dist/l10n/fr.js'
import basic from '../../../mixins/basic'

export default {
    name: 'FncForm',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Switch.name]: Switch,
        Spinner,
        flatPicker,
        Modal,
        FncClosureModal
    },
    mixins: [basic],
    data() {
        return {
            deleteModal: false,
            closureModal: false,

            duplicateFncNum: false,

            flatpickr_config: {
                allowInput: true,
                wrap: true, // set wrap to true only when using 'input-group'
                altFormat: 'd/m/Y',
                altInput: true,
                disableMobile: true,
                mode: 'single',
                dateFormat: 'Y-m-d',
                locale: French,
            },

            selected_importance: true,

            selected_origin: null,

            isFill: false,

            fncList: [],

            managers: [],

            product: {
                options: [],
                loaded: false,
            },

            supplier: {
                options: [],
                loaded: false,
            },

            contact: {
                options: [],
                loaded: false,
            },

            origin_intern: {
                options: [],
                loaded: false,
            },

            origin_extern: {
                options: [],
                loaded: false,
            },

            efficiency: {
                options: [],
                loaded: false,
            },

            controller: {
                options: [],
                loaded: false,
            },

            location: {
                options: [],
                loaded: false,
            },

            yearList: {
                options: [],
                loaded: false,
            },

            corrective_action: false,

            curative_action: false,

            time_limit: false,

            busy: false,
            originallyArchived: false,

            fnc: new Form({
                id: '',
                product_id: '',
                num: '',
                supplier_id: '',
                quantity: 0,
                received_at: '',
                location: '',
                importance: 'mineure',
                cause: '',
                intern_observation: '',
                corrective_action: '',
                currative_action: '',
                recurence: '',
                controlled_by: '',
                archived_at: '',
                origin: '',
                time_limit: '',
                directed_by: '',
                detected_by: '',
                comments: '',
                efficiency: '',
                corrective_efficiency: '',
                files: [],
                causes: [],
                contact_id: '',
                newFiles: true,
                oldFiles: [],
                newAddedFiles: [],
                cost: '',
                declared_by: '',
                curative_action_date: moment().format()
            }),

            mailForm: {
                id: '',
                to: [],
                object: '',
                body: ''
            },
        }
    },
    watch: {
      selected_importance(newVal) {
        this.fnc.importance = newVal ? 'majeure' : 'mineure'
        if (newVal === true) {
          this.corrective_action = true
        } else {
          this.fnc.corrective_efficiency = ''
        }
      },
        selected_origin: function (newVal, oldVal) {
            if (this.isLoaded === true) {
              if(oldVal !== null){
                this.fnc.origin = ''
                this.fnc.detected_by = ''
              }
            }
        },
        'fnc.product_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.refreshCausesList()
                if (oldVal !== '') {
                    this.fnc.supplier_id = ''
                        this.fnc.contacts = ''
                } 
            }
        },
    },
    computed: {
        isLoaded: function () {
            let newCondtion = true
            if (this.$route.params.id !== undefined) {
                newCondtion = this.isFill;
            }

            return this.product.loaded && this.supplier.loaded && this.controller.loaded && this.location.loaded && this.origin_intern.loaded && this.origin_extern.loaded && this.efficiency.loaded && newCondtion;
        },
        cause_sizeLimit: function () {
            return this.fnc.cause === '' ? 'Taille max' + ': ' + 255 + ' caractères' : 'Restant' + ': ' + (255 - this.fnc.cause.length) + ' caractères'
        },
        comment_sizeLimit: function () {
            return this.fnc.comments === '' ? 'Taille max' + ': ' + 255 + ' caractères' : 'Restant' + ': ' + (255 - this.fnc.comments.length) + ' caractères'
        },
        intern_observation_sizeLimit: function () {
            return this.fnc.intern_observation === '' ? 'Taille max' + ': ' + 255 + ' caractères' : 'Restant' + ': ' + (255 - this.fnc.intern_observation.length) + ' caractères'
        },
        corrective_action_sizeLimit: function () {
            return this.fnc.corrective_action === '' ? 'Taille max' + ': ' + 255 + ' caractères' : 'Restant' + ': ' + (255 - this.fnc.corrective_action.length) + ' caractères'
        },
        currative_action_sizeLimit: function () {
            return this.fnc.currative_action === '' ? 'Taille max' + ': ' + 255 + ' caractères' : 'Restant' + ': ' + (255 - this.fnc.currative_action.length) + ' caractères'
        },
        hasCorrectiveAction() {
        return (this.fnc.corrective_action || '').trim().length > 0
      },
        canCloseFnc() {
        return this.fnc.importance !== 'majeure' || this.hasCorrectiveAction
      },
    },
    mounted() {
        moment.locale('fr');


        // Remplir "product_list" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/product/list`).then((response) => {
            this.product.options = response.data
            this.product.options.forEach((product, index) => {
                if (product.suppliers.length === 0) {
                    response.data.splice(index, 1)
                }
            });

            this.product.loaded = true
        })
        // Remplir "location_list" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/location/list`).then((response) => {
            this.location.options = response.data
            this.location.loaded = true
        })
        // Remplir "supplier_list" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/supplier/list`).then((response) => {
            this.supplier.options = response.data
            this.supplier.loaded = true
        })
        // Remplir "contact_list" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/contact/list`).then((response) => {
            this.contact.options = response.data
            this.contact.loaded = true
        })
        // Remplir "origin_list" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/origin/list`).then((response) => {
            this.origin_extern.options = [response.data[3], response.data[4]]
            this.origin_extern.loaded = true
        })

        // Remplir "origin_list" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/departments/list`).then((response) => {
            this.origin_intern.options = response.data
            this.origin_intern.loaded = true
            response.data.forEach(department => {
                this.managers.push(department.manager.id)
            });
          this.managers.sort((a, b) => a.name.localeCompare(b.name));
        })
        // Remplir "efficiency_list" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/efficiency/list`).then((response) => {
            this.efficiency.options = response.data
            this.efficiency.loaded = true
        })
        // Remplir "controller_list" avec un appel GET Axios
        // Attention il faut mettre en controlleur par défaut l'utilisateur connecté
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/controller/list`).then((response) => {
            this.controller.options = response.data
            this.controller.options.sort((a, b) => a.name.localeCompare(b.name));
            this.controller.loaded = true
        })

        EventBus.$on('isAutenticated', args => {
            this.fnc.controlled_by = window.App.id
            this.fnc.declared_by = window.App.id
        })
        if (window.App !== undefined) {
            this.fnc.controlled_by = window.App.id
            this.fnc.declared_by = window.App.id
        }

        // Récupération du détail D'une Fnc pour modification 
        if (this.$route.params.id !== undefined && this.$route.params.type !== 1) {
            this.fnc.id = this.$route.params.id

            this.axios.get(process.env.VUE_APP_API_BASE_URL + 'fnc/' + this.fnc.id).then(response => {

                // Récupérer les propriétés de la FNC dans le formualire 
                let fnc = response.data

                this.fnc.id = fnc.id
                this.fnc.product_id = fnc.product_id
                this.fnc.num = fnc.num
                this.fnc.supplier_id = fnc.supplier_id
                this.fnc.quantity = fnc.quantity
                this.fnc.received_at = fnc.received_at
                this.fnc.location = fnc.location
                this.fnc.importance = fnc.importance
                if (fnc.importance === 'majeure') {
                    this.selected_importance = true
                } else {
                    this.selected_importance = false
                }

                this.fnc.cause = fnc.cause
                this.fnc.causes = fnc.causes
                this.fnc.intern_observation = fnc.intern_observation === null ? '' : fnc.intern_observation
                this.fnc.corrective_action = fnc.corrective_action === null ? '' : fnc.corrective_action
                if (this.fnc.corrective_action !== '') {
                    this.corrective_action = true

                }
                this.fnc.currative_action = fnc.currative_action === null ? '' : fnc.currative_action
                if (this.fnc.currative_action !== '') {
                    this.curative_action = true
                }
                this.fnc.recurence = fnc.recurence
                this.fnc.controlled_by = fnc.controlled_by
                this.fnc.files = fnc.files
                if (fnc.curative_action_date === null) {
                    this.fnc.curative_action_date = moment().format()
                } else {
                    this.fnc.curative_action_date = fnc.curative_action_date
                }



                if (fnc.origin === 'Fournisseur' || fnc.origin === 'Client') {
                    this.selected_origin = true
                } else {
                    this.selected_origin = false
                }

                this.fnc.origin = fnc.origin


                this.fnc.directed_by = fnc.directed_by
                this.fnc.detected_by = fnc.detected_by
                this.fnc.time_limit = fnc.time_limit
                if (this.fnc.time_limit !== null) {
                    this.time_limit = true
                }
                this.fnc.comments = fnc.comments === null ? '' : fnc.comments
                this.fnc.efficiency = fnc.efficiency
                this.fnc.corrective_efficiency = fnc.corrective_efficiency;
                this.fnc.contact_id = fnc.contact_id
                this.isFill = true
                this.fnc.cost = fnc.cost
                this.fnc.declared_by = fnc.declared_by
                this.fnc.archived_at = fnc.archived_at
                this.originallyArchived = !!fnc.archived_at
            })


            //Dupplication de la Fnc
        } else if (this.$route.params.id !== undefined && this.$route.params.type === 1) {

            this.axios.get(process.env.VUE_APP_API_BASE_URL + 'fnc/' + this.$route.params.id).then(response => {
                // Récupérer les propriétés de la FNC dans le formualire 
                let fnc = response.data


                this.fnc.product_id = fnc.product_id
                this.fnc.num = this.getFncNum()
                this.fnc.supplier_id = fnc.supplier_id
                this.fnc.quantity = fnc.quantity
                this.fnc.received_at = fnc.received_at
                this.fnc.location = fnc.location
                this.fnc.importance = fnc.importance
                if (fnc.importance === 'majeure') {
                    this.selected_importance = true
                } else {
                    this.selected_importance = false
                }
                this.fnc.cause = fnc.cause
                this.fnc.causes = fnc.causes
                this.fnc.intern_observation = fnc.intern_observation === null ? '' : fnc.intern_observation
                this.fnc.corrective_action = fnc.corrective_action === null ? '' : fnc.corrective_action
                this.fnc.currative_action = fnc.currative_action === null ? '' : fnc.currative_action
                this.fnc.recurence = fnc.recurence
                this.fnc.controlled_by = fnc.controlled_by
                this.fnc.files = fnc.files

                if (fnc.origin === 'Fournisseur' || fnc.origin === 'Client') {
                    this.selected_origin = true
                } else {
                    this.selected_origin = false
                }

                this.fnc.origin = fnc.origin
                this.fnc.directed_by = fnc.directed_by
                this.fnc.detected_by = fnc.detected_by
                this.fnc.time_limit = fnc.time_limit
                this.fnc.comments = fnc.comments === null ? '' : fnc.comments
                this.fnc.efficiency = fnc.efficiency
                this.fnc.corrective_efficiency = fnc.corrective_efficiency;
                this.fnc.contact_id = fnc.contact_id
                this.isFill = true
                this.fnc.contact_id = fnc.contact_id
                this.fnc.newFiles = false
                this.fnc.oldFiles = fnc.files
                if (fnc.curative_action_date === null) {
                    this.fnc.curative_action_date = moment().format()
                } else {
                    this.fnc.curative_action_date = fnc.curative_action_date
                }
                this.fnc.cost = fnc.cost
                this.fnc.declared_by = fnc.declared_by
            })

        } else {
            this.getFncNum()
            this.fnc.quantity = 1

        }

    },
    methods: {
        finishClosure(prepareEmail) {
            this.closureModal = false
            if (prepareEmail) {
                this.$router.push({ name: 'fnc list', query: { sendCopy: this.fnc.id } })
            } else {
                this.backToList()
            }
        },
        backToList() {
            this.$router.push({ name: 'fnc list' })
        },

        save() {
          if (this.fnc.importance !== 'majeure') {
            this.fnc.corrective_efficiency = ''
          }

          if (this.fnc.importance === 'majeure' && this.fnc.archived_at && !this.hasCorrectiveAction) {
            this.$notify({
              message: 'Impossible de clôturer : une action corrective est obligatoire pour une FNC majeure.',
              type: 'danger',
              verticalAlign: 'bottom'
            })
            this.busy = false
            return
          }

            this.fnc.curative_action_date = moment(this.fnc.curative_action_date).format('YYYY-MM-DD')
            // Ajout de la Fnc
            if (this.fnc.id === '' && this.$route.params.type !== 0) {
                // console.log(this.fnc.oldFiles)

                this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/check`, { params: { num: this.fnc.num, id: this.fnc.id } }).then(response => {
                    if (response.data.status === 'not available') {

                    } else {
                        this.$validator.validateAll().then(value => {
                            if (value) {
                                if (this.corrective_action === false) {
                                    this.fnc.corrective_action = ''
                                }
                                if (this.curative_action === false) {
                                    this.fnc.curative_action = ''
                                    this.fnc.curative_action_date = null
                                }
                                if (this.time_limit === false) {
                                    this.fnc.time_limit = ''
                                }

                                let formData = new FormData()

                                formData.append('files', this.fnc.files)
                                formData.append('fnc', this.fnc)
                                this.fnc.post(process.env.VUE_APP_API_BASE_URL + `fnc/add`, formData).then((response => {
                                    this.$notify({ message: 'La fiche de non-conformité a bien été enregistrée', type: "success", verticalAlign: "bottom" })
                                    this.backToList()
                                }))
                            }
                            this.busy = false
                        })
                    }
                })
                // Mise a jour de la Fnc
            } else {
                this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/check`, { params: { num: this.fnc.num, id: this.fnc.id } }).then(response => {
                    if (response.data.status === 'not available') {

                    } else {
                        this.$validator.validateAll().then(value => {
                            if (value) {
                                if (this.corrective_action === false) {
                                    this.fnc.corrective_action = ''
                                }
                                if (this.curative_action === false) {
                                    this.fnc.currative_action = ''
                                    this.fnc.curative_action_date = null
                                }
                                if (this.time_limit === false) {
                                    this.fnc.time_limit = ''
                                }

                                let formData = new FormData()

                                formData.append('files', this.fnc.files)
                                formData.append('fnc', this.fnc)

                                this.fnc.post(process.env.VUE_APP_API_BASE_URL + `fnc/update/` + this.fnc.id, formData).then((response => {
                                    this.$notify({ message: 'La fiche de non-conformité a bien été Modifiée', type: "success", verticalAlign: "bottom" })
                                    if (this.fnc.archived_at && !this.originallyArchived) {
                                        this.originallyArchived = true
                                        this.closureModal = true
                                        return
                                    }
                                    this.backToList()
                                }))
                            }
                            this.busy = false
                        })
                    }
                })
            }
        },

        // fonction permettant d'incrémenter le num d'une Fnc 
        getFncNum() {
            let actualYear = moment().format('YY')
            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/year`, { params: { year: actualYear } }).then((response) => {
                this.fnc.num = response.data;
                this.checkDuplicateFncNum()
            })
        },

        openImageInNewTab(base64) {
          const byteCharacters = atob(base64.split(',')[1]);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: base64.split(',')[0].split(':')[1].split(';')[0] });
          const blobUrl = URL.createObjectURL(blob);

          window.open(blobUrl);
        },

        checkDuplicateFncNum() {
            this.$validator.validate('num').then(value => {
                if (value === true) {
                    this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/check`, { params: { num: this.fnc.num, id: this.fnc.id } }).then(response => {
                        if (response.data.status === 'not available') {
                            this.duplicateFncNum = true
                        } else {
                            this.duplicateFncNum = false
                        }
                    })
                }
            })
        },

        deletedModal() {
            this.deleteModal = true
        },

        deleteFnc() {
            this.fnc.post(process.env.VUE_APP_API_BASE_URL + `fnc/delete/` + this.fnc.id).then((response => {
                this.$notify({ message: 'La fiche de non-conformité a bien été supprimé', type: "success", verticalAlign: "bottom" })
                this.backToList()
            }))
        },

        // Fonction permettant l'ajout de nouveaux fichiers après vérification de leur taille et de leur format
        filesChange(fileList) {
            // console.log(this.fnc.oldFiles)
            let files = this.fnc.files
            if (fileList.length + files.length > 5) {
                this.$notify({ message: "Vous êtes limité à un maximum de 5 fichiers ", type: "danger", verticalAlign: "bottom" })
            } else {
                const extensionAllowed = new RegExp('image\/.*|application\/pdf');
                Object.values(fileList).forEach((element) => {
                    let isAllowed = true

                    if (!extensionAllowed.test(element.type)) {
                        isAllowed = false
                        this.$notify({ message: "La pièces jointes " + element.name + " a une extension non supportée", type: "danger", verticalAlign: "bottom" })

                    } else if (element.size > 26214400) {
                        isAllowed = false
                        this.$notify({ message: "La pièces jointes " + element.name + " est trop volumineuse", type: "danger", verticalAlign: "bottom" })

                    }

                    if (isAllowed) {
                        element.newPath = URL.createObjectURL(element)
                        files.push(element)
                    }
                })
                document.getElementById('file').value = ""
                this.fnc.files = files
            }
        },

        removeFile(index) {
            this.fnc.files.splice(index, 1)
        },

        addCorrectiveAction() {
            if (this.corrective_action === true) {
                this.corrective_action = false
            } else {
                this.corrective_action = true
            }
        },

        addCurativeAction() {
            if (this.curative_action === true) {
                this.curative_action = false
            } else {
                this.curative_action = true
            }
        },

        addTimeLimit() {
            if (this.time_limit === true) {
                this.time_limit = false
            } else {
                this.time_limit = true
            }
        },

        refreshCausesList() {

            this.fnc.get(process.env.VUE_APP_API_BASE_URL + `cause/` + this.fnc.product_id).then((response => {
                this.fnc.causes = response.data
            }))
        }


    }
}
</script>

<style>
.el-switch.mr-3 { transform: scale(0.9); transform-origin: left center; }

.part-header {
    color: #f96332;
    margin-top: 0;
}

.text-truncate {
    width: 30%;
    display: block;
}

.remove-btn {
    height: 1rem;
    width: 1rem;
    padding: 0;
    padding-top: .05rem;
    border-radius: 100%;
    background-color: #D81616;

}

.label-file {
    color: white !important;
    background-color: #f96332;
    border: 1px solid #f96332;
    border-radius: .55rem;
    text-align: center;
    font-size: .9rem !important;
    font-weight: 500 !important;
}

.test {
    border-color: #D3D3D3 !important;
    border: 1px solid #E3E3E3 !important;
    border-radius: 10px !important;
}

.test:focus {
    border: 1px solid #b7b7b7 !important;
}

.datepicker:focus,
.datepicker .el-input__inner:focus {
    border: 1px solid #e3e3e3;
}

.fnc-date-field.input-group {
    align-items: stretch;
}

.fnc-date-field .input-group-addon {
    align-items: center;
    background: #fff;
    border: 1px solid #d3d3d3;
    border-right: 0;
    border-radius: 10px 0 0 10px;
    color: #7c8798;
    display: flex;
    height: 40px;
    justify-content: center;
    padding: 0;
    width: 42px;
}

.fnc-date-field .datepicker,
.fnc-date-field .flatpickr-input {
    background: #fff;
    border: 1px solid #d3d3d3;
    border-left: 0;
    border-radius: 0 10px 10px 0;
    box-shadow: none;
    color: #2c2c2c;
    flex: 1 1 auto;
    font-size: 13px;
    height: 40px;
    min-width: 0;
    padding: 0 12px 0 6px;
    width: 1%;
}

.fnc-date-field.input-group-focus .input-group-addon,
.fnc-date-field.input-group-focus .datepicker,
.fnc-date-field.input-group-focus .flatpickr-input,
.fnc-date-field:focus-within .input-group-addon,
.fnc-date-field:focus-within .datepicker,
.fnc-date-field:focus-within .flatpickr-input {
    border-color: #f96332;
}

.fnc-date-field .datepicker:disabled,
.fnc-date-field .flatpickr-input:disabled {
    background: #f5f6f7;
    color: #8b95a5;
    cursor: not-allowed;
}

.has-error .el-input .el-input__inner {
    border-color: #ffcfcf !important;
    color: #FF3636 !important;
    background-color: rgba(222, 222, 222, 0.1) !important;
}

.has-error .el-input i.el-select__caret {
    color: #FF3636 !important;
}

.btn-suppr {
    background-color: #D81616;
}

.btn-suppr:hover {
    background-color: #d83b3b;
}

.input-label {
    margin-left: 1rem;
    position: absolute;
    margin-top: -0.5rem;
    background: white;
    z-index: 4;
    padding-right: 3px;
    padding-left: 3px;
    border-radius: 5px;
}

.mb-1rem {
    margin-bottom: 1.6rem;
}

.text-size {
    height: 100%;
}

.text-size input {
    height: 100%;
}

.importance-1 {
    display: flex;
    justify-content: center;
    padding-top: 0.4rem;
    font-weight: 550;
    font-size: 1rem;
    color: white !important;
    width: 50%;
    height: 2.3rem;
    background-color: #f96332;
    border: 1px solid #f96332;
}


.importance-2 {
    display: flex;
    justify-content: center;
    padding-top: 0.4rem;
    font-weight: 550;
    font-size: 1rem;
    width: 50%;
    height: 2.3rem;
    color: #f96332 !important;
    background-color: white;
    border: 1px solid #f96332;
}

.btn-inverse {
    color: #f96332 !important;
    background-color: white;
    border: 1px solid #f96332;
    font-weight: 550;
}

.btn-inverse:focus {
    background-color: white;
}

.radius-1 {
    border-radius: 10px 0 0 10px;
}

.radius-2 {
    border-radius: 0 10px 10px 0;
}

.texts-sizing {
    height: 6rem;
}

.radius {
    border-radius: 10px;
    height: 2.3rem;
}

.comment {
    float: right;
    margin-top: -20px;
    padding-right: 10px;
    font-weight: 500;
    font-size: 0.7rem !important;
    color: #a9a9a9bd;
}</style>
